export const initialFormData = {
    general: {
      cr_project_name: '',
      environment: 'testbed',
      validity_period: '90',
      // custom_store_ids: []
    },
    Postpaid: {
      MSISDN: { store_id: '', material_code: '', quantity: '' },
      'Blank Sim': { store_id: '', material_code: '', quantity: '' },
      eSIM: { store_id: '', material_code: '', quantity: '' },
      VOBB: { region: '', exchange_area: '', charge_area: '', quantity: '' }
    }
  };